import getMessageErrorLabel from "../const/messageErrors";

export const TEMPLATE_PROVIDER_FALLBACK_MESSAGE =
  "No se pudo crear la plantilla de WhatsApp. Contacta a soporte.";
// Meta Cloud API 368 means an account policy restriction, not a template defect.
// https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/
// Reuse the existing dictionary without changing its other consumers.
export const TEMPLATE_PROVIDER_POLICY_MESSAGE = getMessageErrorLabel(368);

// Match the server's prefix/base36-time/six-character-random reference format.
// Prefixes are not restricted to templates: these clients serve other features.
const SUPPORT_REF_PATTERN = /^[a-z][a-z0-9]*-[a-z0-9]+-[a-z0-9]{6}$/;
const MAX_SUPPORT_REF_LENGTH = 64;

export function templateProviderDiagnostics(body) {
  const diagnostics = {};
  if (!body || typeof body !== "object" || Array.isArray(body)) return diagnostics;

  ["providerCode", "providerSubcode"].forEach((field) => {
    if (Number.isSafeInteger(body[field]) && body[field] >= 0) {
      diagnostics[field] = body[field];
    }
  });

  const { supportRef } = body;
  if (
    typeof supportRef === "string" &&
    supportRef.length <= MAX_SUPPORT_REF_LENGTH &&
    SUPPORT_REF_PATTERN.test(supportRef) &&
    !/\s/.test(supportRef)
  ) {
    diagnostics.supportRef = supportRef;
  }
  return diagnostics;
}
